import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'transaction', 'amount',
    'taxData', 'legalName', 'rfc', 'cfdiUse', 'address', 'buyerEmail', 'buyerPhone'
  ]

  copyAmount () {
    if (!this.hasTransactionTarget || !this.hasAmountTarget) return

    const option = this.transactionTarget.selectedOptions[0]
    if (!option) return

    const amount = option.getAttribute('data-amount')
    if (amount !== null && amount !== '') {
      this.amountTarget.value = amount
    }
  }

  prefillFromTaxData () {
    if (!this.hasTaxDataTarget) return

    const option = this.taxDataTarget.selectedOptions[0]
    if (!option || !option.value) return

    this._setEditableFields({
      legalName: option.dataset.legalName,
      rfc: option.dataset.rfc,
      cfdiUse: option.dataset.cfdiUse,
      address: option.dataset.address,
      buyerEmail: option.dataset.buyerEmail
    })
  }

  unlinkTaxData () {
    if (!this.hasTaxDataTarget) return
    if (!this.taxDataTarget.value) return

    const slimSelectController = this._slimSelectController()
    if (slimSelectController?.select?.setSelected) {
      slimSelectController.select.setSelected('')
    } else {
      this.taxDataTarget.value = ''
    }
  }

  _slimSelectController () {
    const wrapper = this.taxDataTarget.closest('[data-controller~="slim-select"]')
    if (!wrapper) return null

    return this.application.getControllerForElementAndIdentifier(wrapper, 'slim-select')
  }

  _setEditableFields ({ legalName, rfc, cfdiUse, address, buyerEmail }) {
    if (this.hasLegalNameTarget) this.legalNameTarget.value = legalName || ''
    if (this.hasRfcTarget) this.rfcTarget.value = rfc || ''
    if (this.hasCfdiUseTarget) this.cfdiUseTarget.value = cfdiUse || ''
    if (this.hasAddressTarget) this.addressTarget.value = address || ''
    if (this.hasBuyerEmailTarget) this.buyerEmailTarget.value = buyerEmail || ''
  }
}
